// Angular
import { CanActivate, Router, ActivatedRouteSnapshot } from "@angular/router";
import { inject, Injectable } from "@angular/core";

// Services
import { UserService } from "#services/user/user.service";

@Injectable({
    providedIn: "root",
})
export class PermissionGuard implements CanActivate {
    private readonly userService = inject(UserService);
    private readonly router = inject(Router);

    canActivate(route: ActivatedRouteSnapshot): boolean {
        const validPermission = route["data"]["can"] ?? null;
        if (validPermission && !this.userService.can(validPermission)) {
            this.router.navigate(["/403"], {
                skipLocationChange: true,
            });

            return false;
        }

        return true;
    }
}
